
<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";

useBackButton();

</script>

<template>

    <div class="bg-white dark:bg-gray-850 tracking-wider text-sm lg:text-base
                 w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="flex justify-center items-center my-6">
            <strong class="text-lg font-bold">Battery Health</strong>
        </div>     

        <div class="flex flex-col w-full gap-3 px-4 lg:px-6">
        
            <h1>
                The lifespan of a car battery can vary depending on factors such 
                as usage, climate, and maintenance practices. However, on average, 
                car batteries typically last anywhere from 3 to 5 years. It's 
                important to replace your car battery within this timeframe for 
                several reasons:
            </h1>

            <div class="pl-2 lg:pl-4 flex flex-col w-full gap-3 dark:text-gray-300">
            
                <p>
                    <span class="dark:text-white">Reliability:</span> As a car battery ages, 
                    its ability to hold a charge diminishes. Regularly replacing your car battery 
                    ensures reliable starting and operation of your vehicle.
                </p>

                <p>
                    <span class="dark:text-white">Prevention of Unexpected Breakdowns:</span> A failing 
                    battery can fail suddenly, leaving you stranded. By replacing your battery within 
                    the recommended timeframe, you reduce the risk of an unexpected breakdown.
                </p>        

                <p>
                    <span class="dark:text-white">Preservation of Vehicle Systems:</span> A weak or failing battery 
                    can put strain on other electrical components of your vehicle, such as the alternator and starter.
                </p>

                <p>
                    <span class="dark:text-white">Resale Value:</span> If you ever decide to sell or trade in your vehicle, 
                    a well-documented service history significantly increases its resale value.
                </p>        

                <p>
                    <span class="dark:text-white">Safety:</span> A properly functioning battery is essential for the 
                    operation of crucial safety features in modern vehicles, such as airbags and electronic stability 
                    control systems.
                </p>

            </div>

            <p>
                Poor battery condition is the number one reason a car has trouble starting, so pay attention
                to the age of your battery and replace it early when it shows sign of trouble.
            </p>  

        </div>

    </div>   
    
</template>
